// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tittle {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: clamp(0.8rem, 2vw, 1.25rem);
}

.story-section {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
  overflow: auto;
  overflow-y: hidden;
}
.story-section .border-wrapper {
  display: inline-block;
  width: clamp(4rem, 5vw, 6rem);
  height: clamp(4rem, 5vw, 6rem);
  min-width: clamp(4rem, 5vw, 6rem);
  min-height: clamp(4rem, 5vw, 6rem);
  border-radius: 50%;
  background: linear-gradient(90deg, rgb(223, 199, 52) 0%, rgb(178, 53, 168) 100%);
  padding: 2px;
}
.story-section .border-wrapper .news-img {
  max-width: 100%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/news/news.component.scss"],"names":[],"mappings":"AAAA;EACI,qCAAA;EACA,iBAAA;EACA,sCAAA;AACJ;;AAEA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AAAI;EACI,qBAAA;EACA,6BAAA;EACA,8BAAA;EACA,iCAAA;EACA,kCAAA;EACA,kBAAA;EACA,gFAAA;EACA,YAAA;AAER;AAAQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAEZ","sourcesContent":[".tittle{\n    font-family: 'Montserrat', sans-serif;\n    font-weight: bold;\n    font-size: clamp(0.8rem, 2vw, 1.25rem);\n}\n\n.story-section{\n    display: flex;\n    gap: 0.75rem;\n    margin-top: 1rem;\n    overflow: auto;\n    overflow-y: hidden;\n    .border-wrapper {\n        display: inline-block;\n        width: clamp(4rem, 5vw, 6rem);\n        height: clamp(4rem, 5vw, 6rem);\n        min-width: clamp(4rem, 5vw, 6rem);\n        min-height: clamp(4rem, 5vw, 6rem);\n        border-radius: 50%;\n        background: linear-gradient(90deg, rgba(223,199,52,1) 0%, rgba(178,53,168,1) 100%);\n        padding: 2px;\n\n        .news-img {\n            max-width: 100%;\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n            object-fit: cover;\n        }\n    }\n    \n\n    \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
